import { z } from "zod";
import { OeePeriodSchema } from "./oee.js";
import { type CommandSpec, Uuid, IsoDate } from "./assistant-catalog-types.js";

// Família Leitura/Exibição (display · safe · OPERADOR · auto-executa no cliente).
const AlarmStateArg = z.enum(["UNACKNOWLEDGED", "ACKNOWLEDGED", "RESOLVED", "SHELVED"]);
const AlarmSeverityArg = z.enum(["LOW", "MEDIUM", "HIGH"]);

export const DISPLAY_COMMANDS: readonly CommandSpec[] = [
  {
    name: "oee.show",
    kind: "display",
    riskTier: "safe",
    minRole: "OPERADOR",
    renderTarget: "inline",
    description:
      "Responde no chat com o OEE (A×P×Q) de uma linha num período, com comparação opcional ao anterior (card compacto na conversa, NÃO abre nenhuma tela).",
    argsSchema: z
      .object({
        lineId: Uuid,
        period: OeePeriodSchema.optional(),
        from: IsoDate.optional(),
        to: IsoDate.optional(),
        compareWithPrevious: z.boolean().optional(),
      })
      .strict(),
  },
  {
    name: "production.showStatus",
    kind: "display",
    riskTier: "safe",
    minRole: "OPERADOR",
    renderTarget: "inline",
    description:
      "Responde no chat com o status da produção ativa de uma linha — produzido, planejado, progresso, ETA (card compacto na conversa, NÃO abre nenhuma tela). Para ABRIR a tela de detalhe da linha, use nav.lineDetail.",
    argsSchema: z.object({ lineId: Uuid }).strict(),
  },
  {
    name: "alarms.show",
    kind: "display",
    riskTier: "safe",
    minRole: "OPERADOR",
    renderTarget: "panel",
    description:
      "Responde no chat com a lista de alarmes (mostra um atalho para a tela), opcionalmente filtrada por linha, estado ou severidade. Para ABRIR a tela de alarmes direto, use nav.alarms.",
    argsSchema: z
      .object({
        lineId: Uuid.optional(),
        state: AlarmStateArg.optional(),
        severity: AlarmSeverityArg.optional(),
      })
      .strict(),
  },
  {
    name: "machineEvents.show",
    kind: "display",
    riskTier: "safe",
    minRole: "OPERADOR",
    renderTarget: "panel",
    description:
      "Responde no chat com os eventos de máquina de uma linha/máquina (mostra um atalho para a tela), opcionalmente num intervalo.",
    argsSchema: z
      .object({
        lineId: Uuid.optional(),
        machineId: Uuid.optional(),
        from: IsoDate.optional(),
        to: IsoDate.optional(),
      })
      .strict(),
  },
  {
    name: "line.showList",
    kind: "display",
    riskTier: "safe",
    minRole: "OPERADOR",
    renderTarget: "panel",
    description:
      "Responde no chat com a lista de linhas de produção (mostra um atalho para a tela). Para ABRIR a tela da lista de linhas direto, use nav.lines.",
    argsSchema: z.object({}).strict(),
  },
  {
    name: "dashboard.showOverview",
    kind: "display",
    riskTier: "safe",
    minRole: "OPERADOR",
    renderTarget: "panel",
    description:
      "Responde no chat com o painel geral, visão consolidada da operação (mostra um atalho para a tela). Para ABRIR o painel geral direto, use nav.dashboard.",
    argsSchema: z.object({}).strict(),
  },
  {
    name: "simulation.showResult",
    kind: "display",
    riskTier: "safe",
    minRole: "OPERADOR",
    renderTarget: "panel",
    description:
      "Responde no chat com o resultado de uma simulação (mostra um atalho para a tela). Para ABRIR a tela do resultado direto, use nav.simulationDetail.",
    argsSchema: z.object({ simulationId: Uuid }).strict(),
  },
  {
    name: "simulation.compare",
    kind: "display",
    riskTier: "safe",
    minRole: "OPERADOR",
    renderTarget: "panel",
    description:
      "Responde no chat com a comparação entre duas simulações (mostra um atalho para a tela). Para ABRIR a comparação lado-a-lado direto, use nav.simulationCompare.",
    argsSchema: z.object({ a: Uuid, b: Uuid }).strict(),
  },
];
